import { lazy } from "react";

const Footer = lazy(() => import("./footer"));
const Sidebar = lazy(() => import("./sidebar"));
const Header = lazy(() => import("./header"));

export { Footer, Sidebar, Header };
